export const emptyDictionariesState = {
  fileCategories: [],
  folders: []
}
